module.exports = __webpack_public_path__ + "img/127.6950b816.jpg";